/**
 * IngredientProvenance - synchronized with the Prisma enum of the same name.
 *
 * Declares whether a manually entered catalog row has been checked against a
 * source (supplier label, technical sheet) or is still an uncontrolled typing.
 * Only these two values exist in this tranche; no other provenance is added.
 */
export const INGREDIENT_PROVENANCES = ['MANUAL_VERIFIED', 'MANUAL_UNVERIFIED'] as const;
export type IngredientProvenance = (typeof INGREDIENT_PROVENANCES)[number];
